const GeneralDashboard = () => import('@/components/general/Dashboard.vue')
const MasterDashboard = () => import('@/components/general/MasterDashboard.vue')

const dashboardPermissions = [
  'dashboard_general'
]

export const dashboardRoutes = [
  {path: '/dashboard', component: GeneralDashboard, meta: { breadcrumb: 'Dashboard Operativo', requiresAuth: true, permissions: dashboardPermissions }},
  {
    path: '/dashboard-master',
    component: MasterDashboard,
    meta: { breadcrumb: 'Dashboard Ejecutivo', requiresAuth: true, permissions: ['dashboard_maestro'] },
  },
]
